import { EventEmitter, Injectable } from '@angular/core';
import { Control } from 'src/classes/Authorization/BusinessRole';

@Injectable({
    providedIn: 'root'
})
export class ControlsService {
    custcardviewControlsChanged: EventEmitter<any> = new EventEmitter();
    custcardviewControls: Control[];

    constructor() { }

    get custcardviewControlsData(): any {
        return this.custcardviewControls;
    }
    set custcardviewControlsData(value: any) {
        this.custcardviewControls = value;
        this.custcardviewControlsChanged.emit(value);
    }
}
